import { differenceInMilliseconds, intervalToDuration } from 'date-fns';
import { getDifferenceInMonth } from './DateUtils40.js';

const getDuration = (leftDate, rightDate) => {
    const difference = differenceInMilliseconds(leftDate, rightDate);
    const duration = intervalToDuration({ start: 0, end: difference > 0 ? difference : 0 });
    const isPast = difference <= 0;
    const requiredDuration = {
        days: 0,
        hours: 0,
        minutes: 0,
        months: 0,
        seconds: 0,
        years: 0,
    };
    Object.keys(duration).forEach((key) => {
        var _a;
        requiredDuration[key] = (_a = duration[key]) !== null && _a !== void 0 ? _a : 0;
    });
    const monthDuration = getDifferenceInMonth(leftDate, rightDate);
    const totalSeconds = difference / 1000;
    const totalMinutes = totalSeconds / 60;
    const totalHours = totalMinutes / 60;
    return Object.assign(Object.assign({}, requiredDuration), { months: monthDuration, isPast, totalSeconds: totalSeconds, totalMinutes: totalMinutes, totalHours: totalHours });
};

export { getDuration };
